import { render } from "./store-list.vue?vue&type=template&id=c976530a"
import script from "./store-list.vue?vue&type=script&lang=js"
export * from "./store-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__